export const faqs = [
  {
    id: "faq-1",
    question: "什么是球幕影院？它和普通影厅有什么不同？",
    answer: "球幕影院采用半球形银幕，画面从水平方向一直延伸到观众头顶，配合多机融合投影与环绕声系统，让观众被影像 360 度包裹，获得近似身临其境的沉浸感。普通影厅为平面银幕，视野边界明显，而球幕影厅几乎消除了画面边框。",
  },
  {
    id: "faq-2",
    question: "观影过程中如果感到不适怎么办？",
    answer: "部分观众在观看高速运动镜头时可能会有轻微眩晕感。我们建议首次体验的观众优先选择中后排座位，并可在入场前向工作人员索取舒缓眼罩。若观影中感到不适，可随时离场休息，工作人员会协助您调整座位。",
  },
  {
    id: "faq-3",
    question: "儿童可以入场吗？有年龄限制吗？",
    answer: "大多数自然纪录片与亲子影片适合 5 岁以上儿童观看，亲子场次欢迎家庭共同入场。对于含强烈声光刺激的科幻影片，我们建议 8 岁以上观众观看，具体以影片详情页标注的适龄提示为准。",
  },
  {
    id: "faq-4",
    question: "如何选座？可以提前多久入场？",
    answer: "购票时可在线自主选座，穹顶厅采用环绕式阶梯布局，中环位置视角最佳。放映前 20 分钟开始检票入场，建议提前 15 分钟到达，以便熟悉穹顶环境并观看映前技术介绍。",
  },
  {
    id: "faq-5",
    question: "场馆内可以拍照或录像吗？",
    answer: "为保护版权并避免影响他人，放映过程中禁止拍照、录像与使用闪光灯。映前可在主题展厅与穹顶模型前自由拍照留念，我们也在厅外设置了最佳打卡点。",
  },
  {
    id: "faq-6",
    question: "可以退票或改期吗？",
    answer: "场次开始前 2 小时可免费改期一次；开始前 1 小时以上申请退票可退还 80% 票款，具体以购票须知为准。若因场馆原因取消场次，我们将全额退款并赠送体验券。",
  },
  {
    id: "faq-7",
    question: "场馆是否提供无障碍设施与寄存服务？",
    answer: "场馆设有无障碍坡道、无障碍座位与专用卫生间，并提供轮椅借用服务。一层大厅设有免费自助寄存柜，大件行李可交由前台寄存。",
  },
];